import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { IoPerson, IoDocumentTextSharp } from "react-icons/io5";
import { GrAttraction } from "react-icons/gr";
import { MdOutlineAttractions, MdEvent } from "react-icons/md";
import { FaFileContract } from "react-icons/fa6";
import { FaPlaceOfWorship } from "react-icons/fa";
import PartnerRegistrationNavBar from '../../components/navbar/registration/PartnerRegistrationNavBar';
import ResponsiveTab from '../../components/PartnerRegistration/ResponsiveTab';
import TabContent from '../../components/PartnerRegistration/TabContent';

const PartnerRegistration = () => {
  const { registrationType } = useParams();
  const [activeTab, setActiveTab] = useState(0);
  const [completedTabs, setCompletedTabs] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8]);

  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    phone_number: '',
    email_id: '',
    password: '',
    locality: '',
    role: '',
    type: registrationType === 'event' ? 'Event' : registrationType === 'temple' ? 'Temple' : 'Venue',
    workingHours: {
      businessDay: { open: new Date(), close: new Date() },
      weekend: { open: new Date(), close: new Date() },
      publicHoliday: { open: new Date(), close: new Date() },
    },
    amenities: [],
    images: [],
    eventDetails: {},
    templeDetails: {}
  });

  const allTabs = [
    { title: "Partner Information", icon: <IoPerson size={24} />, description: "Basic information about partner" },
    { title: "Venue Information", icon: <GrAttraction size={24} />, description: "Venue address and details" },
    { title: "Product Information", icon: <MdOutlineAttractions size={24} />, description: "Products or services offered" },
    { title: "Event Information", icon: <MdEvent size={24} />, description: "Details about events" },
    { title: "Temple Information", icon: <FaPlaceOfWorship size={24} />, description: "Details about temples" },
    { title: "Registration Details", icon: <MdEvent size={24} />, description: "Details about event registration" },
    { title: "Organization Details", icon: <IoPerson size={24} />, description: "Details about the organization" },
    { title: "Partner Contract", icon: <FaFileContract size={24} />, description: "Legal agreements and contracts" },
    { title: "Required Documents", icon: <IoDocumentTextSharp size={24} />, description: "Upload necessary documents" }
  ];

  const filteredTabs =
    registrationType === 'venue'
      ? [0, 1, 7, 8]
      : registrationType === 'event'
      ? [0, 3, 5, 6, 7, 8]
      : [0, 4, 7, 8];

  const tabTitles = filteredTabs.map((index) => allTabs[index]);

  const moveToNextTab = () => {
    if (!completedTabs.includes(activeTab)) {
      setCompletedTabs([...completedTabs, activeTab]);
    }
    if (activeTab < tabTitles.length - 1) {
      setActiveTab(activeTab + 1);
    }
  };

  const moveToPreviousTab = () => {
    if (activeTab > 0) {
      setActiveTab(activeTab - 1);
    }
  };

  return (
    <>
      <PartnerRegistrationNavBar />
      <div className="container mx-auto py-6">
        <h2 className="text-3xl font-bold mb-6 text-center">Partner Registration</h2>

        {/* Responsive Layout */}
        <div className="flex flex-col md:flex-row">
          {/* Horizontal Tabs for Mobile */}
          <div className="md:hidden">
            <ResponsiveTab
              tabTitles={tabTitles}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              completedTabs={completedTabs}
            />
          </div>

          <div className="flex flex-col md:flex-row w-full">
            {/* Vertical Tabs for Larger Screens */}
            <div className="hidden md:block w-1/4">
              <ResponsiveTab
                tabTitles={tabTitles}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                completedTabs={completedTabs}
              />
            </div>

            {/* Tab Content */}
            <div className="w-full md:w-3/4 bg-white p-6 rounded-lg shadow-lg">
              <TabContent
                activeTab={filteredTabs[activeTab]}
                formData={formData}
                setFormData={setFormData}
                moveToNextTab={moveToNextTab}
                moveToPreviousTab={moveToPreviousTab}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PartnerRegistration;
